import { inject, Injectable } from '@angular/core';
import { FeatureService, PermissionService } from '../../core/services/permission';

@Injectable({ providedIn: 'root' })
export class JobsFeatureAccessService {
    #permissionService = inject(PermissionService);
    #featureService = inject(FeatureService);

    canAccessJobDetails() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-jobs.job-details') &&
            this.#featureService.isStateAvailable('jobs.view.details') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessJobSchedule() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-schedules.schedule-menu') &&
            this.#featureService.isStateAvailable('jobs.view.schedule') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessJobActualCostings() {
        return (
            (this.#permissionService.isAvailable('jobs.maintain-job-costings.actual-items-menu') &&
                this.#featureService.isStateAvailable('jobs.view.costings')) ||
            this.#hasCompactJobs()
        );
    }

    canAccessPurchaseOrders() {
        return (
            (this.#permissionService.isAvailable('jobs.maintain-purchase-orders.purchase-orders-menu') &&
                this.#featureService.isStateAvailable('jobs.view.costings')) ||
            this.#hasCompactJobs()
        );
    }

    canAccessJobWorkOrders() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-work-orders.work-orders-menu') &&
            this.#featureService.isStateAvailable('jobs.view.costings') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessJobSelections() {
        return this.#permissionService.isAvailable('jobs.selections.view') && !this.#hasCompactJobs();
    }

    canAccessJobActivityFeed() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-jobs.job-details') &&
            this.#featureService.isStateAvailable('jobs.view.details') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessJobVariations() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-variations.variations-menu') &&
            this.#featureService.isStateAvailable('jobs.view.variations') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessJobQuoteRequests() {
        return (
            this.#permissionService.isAvailable('request-for-quote.rfq-access.rfq-menu') &&
            this.#featureService.isStateAvailable('quoterequests') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessContractPriceInvoices() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-invoices.invoicing-menu') &&
            this.#featureService.isStateAvailable('jobs.view.invoices') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessCostPlusInvoices() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-invoices.invoicing-menu') &&
            this.#featureService.isStateAvailable('jobs.view.invoices-cost-plus') &&
            !this.#hasCompactJobs()
        );
    }

    canAccessCompPercInvoices() {
        return (
            this.#permissionService.isAvailable('jobs.maintain-invoices.invoicing-menu') &&
            this.#featureService.isStateAvailable('jobs.view.invoices-comp-perc') &&
            !this.#hasCompactJobs()
        );
    }

    #hasCompactJobs() {
        return this.#featureService.isAvailable('compact-jobs');
    }
}
